"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlModelesDocuments", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      directory: "<"
    },
    transclude: true,
    template: require("./tlModelesDocuments.html"),
    controller: function controller($scope, $http) {
      var ctrl = this;
      $scope.loading = true;
      $http.get('/rest/modeles-documents/list').then(function (response) {
        $scope.documents = response.data;
      }).finally(function () {
        $scope.loading = false;
      });
      $scope.documentsTableConfig = {
        source: "documents",
        columns: [{
          title: 'Document',
          attribute: "description",
          template: '<div>{{model.description}}</div>',
          sortable: true
        }, {
          attribute: "id",
          cellClass: "align-c",
          width: "100px",
          template: '<file-download-link url="/rest/modeles-documents/download?modeleDocumentId={{model.id}}" tl-tooltip="Télécharger">' + '                <i class="icon fa fa-download"></i>' + '      </file-download-link>'
        }]
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/tlModelesDocuments.js
// module id = 2779
// module chunks = 13